import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

export function StoreProvider({ children }) {
  const { user } = useAuth();
  const [store, setStore] = useState(null);
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadStores = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/stores");
      setStores(data);
      if (data.length) {
        const saved = localStorage.getItem("cc_store_id");
        const active = data.find((s) => s.id === saved) || data[0];
        localStorage.setItem("cc_store_id", active.id);
        setStore(active);
      } else {
        setStore(null);
      }
    } catch {
      setStore(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // Reload stores whenever auth state resolves to an authenticated user.
  useEffect(() => {
    if (user) { loadStores(); }
    else if (user === false) { setStore(null); setStores([]); setLoading(false); }
  }, [user, loadStores]);

  const selectStore = (s) => {
    localStorage.setItem("cc_store_id", s.id);
    setStore(s);
  };

  const refreshStore = async () => {
    const { data } = await api.get("/stores/current");
    setStore((prev) => ({ ...prev, ...data }));
  };

  return (
    <StoreContext.Provider value={{ store, stores, loading, loadStores, selectStore, refreshStore, setStore }}>
      {children}
    </StoreContext.Provider>
  );
}
